import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  ButtonBase,
  Divider,
  LinearProgress,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AwnLogo from '../../assets/logo-AW.svg';
import { DASHBOARD, PROFILE } from '../../router/constants';
import NavBreadcrumbs from './NavBreadcrumbs';
import Awn1Icon from '../../assets/awn1.svg';
import Awn2Icon from '../../assets/awn2.svg';
import { useUserRoles } from '../../hooks/useUserRoles';

const Header = ({
  loading,
  handleDrawer
}: {
  loading: boolean;
  handleDrawer: () => void;
}): JSX.Element => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const { isAdmin } = useUserRoles();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: 'white' }}
      elevation={1}
    >
      {loading && (
        <Box sx={{ width: '100%', position: 'absolute', top: 0 }}>
          <LinearProgress sx={{ height: '4px' }} />
        </Box>
      )}
      <Toolbar style={{ minHeight: '85px' }}>
        <IconButton
          aria-label="open drawer"
          onClick={handleDrawer}
          edge="start"
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <img
          style={{ height: '35px', cursor: 'pointer' }}
          src={AwnLogo}
          alt="awn-logo"
          onClick={() => navigate(DASHBOARD)}
        />
        <NavBreadcrumbs />
        <Box flexGrow={1} />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
          }}
        >
          <Typography mr={1}>{keycloak.tokenParsed?.name}</Typography>
          <IconButton onClick={handleClick}>
            <AccountCircleIcon fontSize="large" color="secondary" />
          </IconButton>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 0.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              '& .MuiList-root': {
                paddingBottom: 0
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 20,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0
              }
            }
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <Box pl={2}>Account Settings</Box>
          {isAdmin && (
            <Box>
              <Divider sx={{ my: 1 }} />
              <MenuItem sx={{ pr: 3 }}>
                <ListItemIcon>
                  <img src={Awn1Icon} alt="" />
                </ListItemIcon>
                Manage Admin 1.0
              </MenuItem>
              <MenuItem sx={{ pr: 3 }}>
                <ListItemIcon>
                  <img src={Awn2Icon} alt="" />
                </ListItemIcon>
                Manage Admin 2.0
              </MenuItem>
            </Box>
          )}
          <Divider />
          <MenuItem onClick={() => navigate(PROFILE)} sx={{ pr: 3 }}>
            <ListItemIcon>
              <AccountCircleIcon fontSize="small" />
            </ListItemIcon>
            My Profile
          </MenuItem>
          <ButtonBase
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              cursor: 'pointer',
              mt: 1,
              bgcolor: 'primary.main',
              color: 'white',
              height: '40px',
              borderBottomLeftRadius: 5,
              borderBottomRightRadius: 5
            }}
            onClick={() => keycloak.logout()}
          >
            <Typography color="white">Sign Out</Typography>
          </ButtonBase>
        </Menu>{' '}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
